module.exports = __webpack_public_path__ + "img/urban@2x.641af9b.jpg";